module.exports = __webpack_public_path__ + "media/home1-left.50b89119.mp4";